'use strict'

var toCamelFn = function(str, letter){
       return letter ? letter.toUpperCase(): ''
   }

var hyphenRe = require('./hyphenRe')

module.exports = function(str){
   return str?
          str.replace(hyphenRe, toCamelFn):
          ''
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/to-style/src/stringUtils/camelize.js
// module id = 365
// module chunks = 0